import { ProductDesign, ProductType } from '@inter-ikea-storageone/range';
import { ProductListConfig } from 'rangeConfig/@types';
import addProduct from 'rangeConfig/shared/behaviors/addProduct';
import { getMPPImage } from 'products';
import ImageBanner from 'components/ProductSidebar/CategoryWidget/ImageBanner';
import showTVSheet from 'rangeConfig/shared/features/TVFeature/behaviors/showTVSheet';

const commonProductListConfig = {
  cardsTitle: '',
  cardsSubtitle: 'typeName, designText, communicatedSizeText',
  infoButtonAriaLabel: 'storageone.productListCabinetsTitle',
  mobileCardText: 'communicatedSizeText',
  productCardHoverImage: getMPPImage,
  cluster: [],
  sortOrder: [{ path: 'dimensions.width' }, { path: 'dimensions.height' }]
};

export const desktopProductListConfig: ProductListConfig = {
  ...commonProductListConfig,
  behaviors: {
    productClicked: [addProduct, showTVSheet],
    productDropped: [addProduct, showTVSheet]
  },
  categories: [
    {
      id: 'frames-d-25',
      categoryTitle:
        'storageone.depth communicatedDimensionsLocalized.depth communicatedDimensionsLocalized.unit',
      products: [
        { path: 'type', value: ProductType.EKET_FRAME },
        { path: 'communicatedDimensions.depth', value: 250 },
        { path: 'type', value: ProductType.EKET_FRAME_WITH_GLASS_DOOR_ASM }
      ]
    },
    {
      id: 'frames-d-35',
      categoryTitle:
        'storageone.depth communicatedDimensionsLocalized.depth communicatedDimensionsLocalized.unit',
      products: [
        { path: 'type', value: ProductType.EKET_FRAME },
        { path: 'communicatedDimensions.depth', value: 350 },
        { path: 'type', value: ProductType.EKET_FRAME_WITH_GLASS_DOOR_ASM }
      ]
    },
    {
      id: 'frames-media',
      categoryTitle: 'typeName',
      widgets: [{ component: ImageBanner }],
      products: [{ path: 'type', value: ProductType.EKET_MEDIA_FRAME }]
    }
  ]
};

export const mobileProductListConfig: ProductListConfig = {
  ...commonProductListConfig,
  behaviors: {
    productClicked: [addProduct],
    productDropped: [addProduct]
  },
  categories: [
    {
      id: 'frameWhite',
      categoryTitle: 'designText typeName',
      products: [
        { path: 'type', value: ProductType.EKET_FRAME },
        { path: 'type', value: ProductType.EKET_FRAME_WITH_GLASS_DOOR_ASM },
        { path: 'design', value: ProductDesign.WHITE }
      ]
    },
    {
      id: 'frameWSO',
      categoryTitle: 'designText typeName',
      products: [
        { path: 'type', value: ProductType.EKET_FRAME },
        { path: 'type', value: ProductType.EKET_FRAME_WITH_GLASS_DOOR_ASM },
        { path: 'design', value: ProductDesign.WHITE_STAINED_OAK }
      ]
    },
    {
      id: 'frameBeige',
      categoryTitle: 'designText typeName',
      products: [
        { path: 'type', value: ProductType.EKET_FRAME },
        { path: 'type', value: ProductType.EKET_FRAME_WITH_GLASS_DOOR_ASM },
        { path: 'design', value: ProductDesign.BEIGE }
      ]
    },
    {
      id: 'frameRB',
      categoryTitle: 'designText typeName',
      products: [
        { path: 'type', value: ProductType.EKET_FRAME },
        { path: 'type', value: ProductType.EKET_FRAME_WITH_GLASS_DOOR_ASM },
        { path: 'design', value: ProductDesign.RED_BROWN }
      ]
    },
    {
      id: 'frameLG',
      categoryTitle: 'designText typeName',
      products: [
        { path: 'type', value: ProductType.EKET_FRAME },
        { path: 'type', value: ProductType.EKET_FRAME_WITH_GLASS_DOOR_ASM },
        { path: 'design', value: ProductDesign.LIGHT_GREEN }
      ]
    },
    {
      id: 'frameDG',
      categoryTitle: 'designText typeName',
      products: [
        { path: 'type', value: ProductType.EKET_FRAME },
        { path: 'type', value: ProductType.EKET_FRAME_WITH_GLASS_DOOR_ASM },
        { path: 'design', value: ProductDesign.DARK_GREY }
      ]
    },
    {
      id: 'framePINK',
      categoryTitle: 'designText typeName',
      products: [
        { path: 'type', value: ProductType.EKET_FRAME },
        { path: 'type', value: ProductType.EKET_FRAME_WITH_GLASS_DOOR_ASM },
        { path: 'design', value: ProductDesign.PALE_PINK }
      ]
    },
    {
      id: 'frameLightGrey',
      categoryTitle: 'designText typeName',
      products: [
        { path: 'type', value: ProductType.EKET_FRAME },
        { path: 'type', value: ProductType.EKET_FRAME_WITH_GLASS_DOOR_ASM },
        { path: 'design', value: ProductDesign.LIGHT_GREY }
      ]
    },
    {
      id: 'frameBWE',
      categoryTitle: 'designText typeName',
      products: [
        { path: 'type', value: ProductType.EKET_FRAME },
        { path: 'type', value: ProductType.EKET_FRAME_WITH_GLASS_DOOR_ASM },
        { path: 'design', value: ProductDesign.BROWN_WALNUT_EFFECT }
      ]
    },
    {
      id: 'frameWood',
      categoryTitle: 'designText typeName',
      products: [
        { path: 'type', value: ProductType.EKET_FRAME },
        { path: 'type', value: ProductType.EKET_FRAME_WITH_GLASS_DOOR_ASM },
        { path: 'design', value: ProductDesign.WOOD }
      ]
    },
    {
      id: 'frameMetal',
      categoryTitle: 'designText typeName',
      products: [
        { path: 'type', value: ProductType.EKET_FRAME },
        { path: 'type', value: ProductType.EKET_FRAME_WITH_GLASS_DOOR_ASM },
        { path: 'design', value: ProductDesign.METAL }
      ]
    },
    {
      id: 'frameGreyGreen',
      categoryTitle: 'designText typeName',
      products: [
        { path: 'type', value: ProductType.EKET_FRAME },
        { path: 'type', value: ProductType.EKET_FRAME_WITH_GLASS_DOOR_ASM },
        { path: 'design', value: ProductDesign.GREY_GREEN }
      ]
    },
    {
      id: 'frameLightGreyBlue',
      categoryTitle: 'designText typeName',
      products: [
        { path: 'type', value: ProductType.EKET_FRAME },
        { path: 'type', value: ProductType.EKET_FRAME_WITH_GLASS_DOOR_ASM },
        { path: 'design', value: ProductDesign.LIGHT_GREY_BLUE }
      ]
    },
    {
      id: 'framePaleYellow',
      categoryTitle: 'designText typeName',
      products: [
        { path: 'type', value: ProductType.EKET_FRAME },
        { path: 'type', value: ProductType.EKET_FRAME_WITH_GLASS_DOOR_ASM },
        { path: 'design', value: ProductDesign.PALE_YELLOW }
      ]
    }
  ]
};
